import { PropTypes } from 'prop-types';
import React, { forwardRef } from 'react';

import { COLORS } from '../../../constants/colors';
import { toCamelCase } from '../../../utils';
import ArticleHeroImage from '../ArticleHeroImage';

const ArticleHeader = forwardRef(({ header, heroImage }, ref) => {
  const backgroundColor = COLORS[toCamelCase(header.backgroundColor)];
  const color = toCamelCase(header.textColor);
  return (
    <div ref={ref}>
      <div className={`article__header ${color}`} style={{ backgroundColor }}>
        <div className="article__header--container">
          <h1>{header.title}</h1>
          <div className="subhead">{header.headline}</div>
        </div>
      </div>
      {heroImage && (
        <ArticleHeroImage
          image={heroImage.image}
          title={heroImage.title}
          wistiaVideoId={heroImage.wistiaVideoId}
        />
      )}
    </div>
  );
});

ArticleHeader.propTypes = {
  header: PropTypes.object,
  heroImage: PropTypes.object,
};

export default ArticleHeader;
